import { Box } from "@mui/material";
import { Spin } from "antd";
import React from "react";
// import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';

const LoadingComponent = ({ inline, text }) => {
    // const { t } = useTranslation();

    return (
        <Box
            sx={{
                backgroundColor: "rgba(52, 52, 52, 0.2)",
                position: "fixed",
                zIndex: "10000",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                "& > div": {
                    position: "absolute",
                    zIndex: "10001",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                },
            }}
        >
            {/* <Spin size="large" tip={text || `Loading...`} /> */}
            {/* <Spin size="large" /> */}
            <Box sx={{ display: 'flex' }}>
                <CircularProgress size={50} value={100} thickness={4} />
            </Box>
        </Box>
    );
};

export default LoadingComponent;
